import { render, staticRenderFns } from "./fieldCustomerAddressSelect.vue?vue&type=template&id=3370d1d4&"
import script from "./fieldCustomerAddressSelect.vue?vue&type=script&lang=js&"
export * from "./fieldCustomerAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports